import script from "./RecipeTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeTable.vue?vue&type=script&setup=true&lang=ts"

import "./RecipeTable.vue?vue&type=style&index=0&id=531aff86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531aff86"]])

export default __exports__